export default {
  mutations: {
    SET_BANK_ACCOUNT_TYPES: 'SET_BANK_ACCOUNT_TYPES',
    SET_BILLING_TYPES: 'SET_BILLING_TYPES',
  },
  getters: {
    GET_BANK_ACCOUNT_TYPES: 'GET_BANK_ACCOUNT_TYPES',
    GET_BILLING_TYPES: 'GET_BILLING_TYPES',
  },
  actions: {
    BANK_ACCOUNT_TYPES: 'BANK_ACCOUNT_TYPES',
    BILLING_TYPES: 'BILLING_TYPES',
  },
};
